// priority 1...10
// blocker
// emergency

export const PriorityMainPalette: any = {
    1: '#23C6FF',
    2: '#23C6FF',
    3: '#43A5FF',
    4: '#43A5FF',
    // 5: '#3F74FC',
    5: '#7C848F', // experiemntal
    6: '#FF841F',
    7: '#FF6737',
    8: '#FF6737',
    9: '#FF6737',
    10: '#FF6737',
    50: '#EF3F3C',
    100: '#EF3F3C'
}


export const PriorityMainBorderPalette: any = {

    1: '#1AB4EA',
    2: '#1AB4EA',
    3: '#2E8DE5',
    4: '#2E8DE5',
    // 5: '#2661F7',
    5: '#7C848F', // experiemntal
    6: '#EC720E',
    7: '#E95627',
    8: '#E95627',
    9: '#E95627',
    10: '#E95627',
    50: '#CE2623',
    100: '#CE2623',

}